const Report = () =>
  import(/* webpackChunkName: "order-batch" */ '@/pages/order/batch/index.vue')
const Detail = () =>
  import(/* webpackChunkName: "order-batch" */ '@/pages/order/batch/detail.vue')

export default {
  path: 'batch',
  meta: {
    label: 'batchOrder',
    auth: 'batch.batch'
  },
  component: {
    name: 'Batch',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'OrderBatchReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'OrderBatchDetail',
      path: 'detail',
      meta: {
        label: 'detail',
        auth: 'detail'
      },
      component: Detail
    }
  ]
}
